/**
 * Normalize phone display/save values (DEEP-BUG-038).
 * Strips non-digits except a leading +, and collapses accidental concatenations
 * (e.g. repeated numbers glued together) to a single Indian mobile when possible.
 */
export function normalizePhoneInput(raw: unknown): string {
  const text = String(raw ?? '').trim();
  if (!text) return '';

  const hasPlus = text.startsWith('+');
  const digits = text.replace(/\D/g, '');
  if (!digits) return '';

  // Prefer last 10 digits when value looks like concatenated Indian mobiles.
  if (digits.length > 12 && digits.length % 10 === 0) {
    return `${hasPlus ? '+' : ''}${digits.slice(-10)}`;
  }
  if (digits.length > 12 && digits.endsWith(digits.slice(0, digits.length - 10))) {
    return `${hasPlus ? '+' : ''}${digits.slice(-10)}`;
  }
  // Common: 91XXXXXXXXXX or 0XXXXXXXXXX
  if (digits.length === 12 && digits.startsWith('91')) {
    return `${hasPlus ? '+' : ''}${digits}`;
  }
  if (digits.length > 15) {
    return `${hasPlus ? '+' : ''}${digits.slice(-12)}`;
  }
  return `${hasPlus ? '+' : ''}${digits}`;
}

const INDIAN_MOBILE_NATIONAL = /^[6-9]\d{9}$/;

/**
 * 10-digit Indian mobile used for OTP and stored account phones.
 * Accepts +91, leading 0, spaces, and a repeated number glued together.
 */
export function toNationalIndianMobile(raw: unknown): string {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (!digits) return '';

  let national = digits;
  if (national.length >= 12 && national.startsWith('91')) {
    national = national.slice(-10);
  } else if (national.length === 11 && national.startsWith('0')) {
    national = national.slice(1);
  } else if (national.length > 10) {
    national = national.slice(-10);
  }

  return INDIAN_MOBILE_NATIONAL.test(national) ? national : '';
}
